export function Privacy(): JSX.Element {
  return (
    <article>
      <h1 className="text-[28px] font-semibold text-ink mb-2">隐私协议</h1>
      <p className="text-ink-muted mb-10">最后更新：2026 年 4 月</p>

      <div className="space-y-8 text-[14px] text-ink-muted leading-relaxed">
        <section>
          <h2 className="text-[18px] font-semibold text-ink mb-3">概述</h2>
          <p>
            哪都通（以下简称"我们"）尊重并保护用户隐私。本协议说明我们在提供 API 网关服务过程中如何收集、使用和保护你的信息。使用我们的服务即表示你同意本协议的条款。
          </p>
        </section>

        <section>
          <h2 className="text-[18px] font-semibold text-ink mb-3">我们收集的信息</h2>
          <ul className="space-y-2">
            <li className="flex items-start gap-2">
              <span className="text-claude mt-0.5">·</span>
              <span><strong className="text-ink">账户信息</strong>：注册时提供的邮箱地址，用于身份验证和服务通知</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-claude mt-0.5">·</span>
              <span><strong className="text-ink">用量数据</strong>：API 请求的元数据（时间戳、模型名称、Token 数量、费用），用于计费和用量统计</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-claude mt-0.5">·</span>
              <span><strong className="text-ink">支付信息</strong>：充值相关的交易记录，由第三方支付平台处理，我们不直接存储银行卡或支付账户信息</span>
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-[18px] font-semibold text-ink mb-3">我们不收集的信息</h2>
          <div className="rounded-xl bg-butter/40 p-5">
            <p className="font-semibold text-ink mb-2">我们不记录、不缓存、不存储你的 API 请求和响应内容。</p>
            <p>
              哪都通是透传网关。你发送给模型的 prompt、模型返回的回复，全程透传到上游厂商，在我们的系统中不落盘、不留痕。我们只记录请求的元数据（Token 数量、费用）用于计费。
            </p>
          </div>
        </section>

        <section>
          <h2 className="text-[18px] font-semibold text-ink mb-3">信息的使用</h2>
          <p>我们收集的信息仅用于：</p>
          <ul className="space-y-1.5 mt-2">
            <li className="flex items-start gap-2">
              <span className="text-claude mt-0.5">·</span>
              <span>提供和维护 API 网关服务</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-claude mt-0.5">·</span>
              <span>计费、账单和余额管理</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-claude mt-0.5">·</span>
              <span>服务异常通知和安全告警</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-claude mt-0.5">·</span>
              <span>改进服务质量和稳定性</span>
            </li>
          </ul>
          <p className="mt-3">我们不会将你的信息出售给第三方，也不会用于广告投放。</p>
        </section>

        <section>
          <h2 className="text-[18px] font-semibold text-ink mb-3">数据安全</h2>
          <p>
            所有数据传输使用 TLS 加密。账户认证信息加密存储。API Key 在创建后不可再次查看——系统只保存哈希值。我们的基础设施运行在 Cloudflare 全球网络上，享有其企业级安全防护。
          </p>
        </section>

        <section>
          <h2 className="text-[18px] font-semibold text-ink mb-3">数据保留</h2>
          <p>
            用量记录保留 90 天，用于账单查询和争议处理。账户注销后，个人信息在 30 天内删除。匿名化的汇总统计数据（总请求量、总 Token 量等）可能长期保留用于服务改进。
          </p>
        </section>

        <section>
          <h2 className="text-[18px] font-semibold text-ink mb-3">联系方式</h2>
          <p>
            对本隐私协议有任何问题，请联系：<a href="mailto:support@nadoutong.org" className="text-claude hover:underline">support@nadoutong.org</a>
          </p>
        </section>
      </div>
    </article>
  );
}
